import { FormInputConfig, AllInputTypes } from '../../../../../../trash/shared/interfaces/form-input-config';
import { FormComponent } from '../../../../../../trash/shared/components/dynamic-form/form/form.component';
import { ToastService } from '../../../../../../trash/shared/components/toasters/Toast.service';
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { UsersService } from '../../services/users.service';
import { ChangeDetectorRef, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { Subscription, Subject } from 'rxjs';
import { getIdFormConfig } from '../../../../../../views/pages/adminstration/temp-common/utils';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-create-update-user',
    standalone: true,
    imports: [ReactiveFormsModule, CommonModule, DialogModule, ButtonModule, FormsModule, FormComponent, TranslateModule],
    templateUrl: './create-update-user.component.html',
    styleUrl: './create-update-user.component.scss'
})
export class CreateUpdateUserComponent {
    private subscriptions: Subscription[] = [];

    isLoadingAddEditItem = false;
    form: FormInputConfig[] = [];
    formValues: any = null;
    UserId: string | undefined;
    validationErrors: any = {};
    validationEmit = false;
    private searchSubject = new Subject<any>();

    constructor(
        private _UsersService: UsersService,
        public dataObj: DynamicDialogConfig,
        private toastService: ToastService,
        private cdr: ChangeDetectorRef,
        private ref: DynamicDialogRef,
        private translate: TranslateService
    ) {}

    ngOnInit(): void {
        this.UserId = this.dataObj?.data?.item?.id;
        if (this.UserId) {
            this.formValues = this.dataObj?.data?.item;
        }

        this.initForm();
    }

    onFilterSelect(e: any) {
        this.searchSubject.next(e);
    }

    // Initialize the form
    initForm() {
        if (this.UserId) {
            // Fields for editing an existing user
            this.form = [
                getIdFormConfig(this.dataObj?.data?.item?.id),
                {
                    type: AllInputTypes.Text,
                    name: 'firstName',
                    label: this.translate.instant('FORMS.FIRST_NAME'),
                    placeholder: `${this.translate.instant('FORMS.EX')} ${this.translate.instant('FORMS.FIRST_NAME')}`,
                    defaultValue: this.formValues?.firstName,
                    isDisable: !this.dataObj?.data?.visible,
                    widthClass: 'col-12',
                    validation: [{ function: Validators.required, errorMessage: `${this.translate.instant('GENERAL.PLEASE_ENTER')} ${this.translate.instant('FORMS.FIRST_NAME')}` }]
                },
                {
                    type: AllInputTypes.Text,
                    name: 'lastName',
                    label: this.translate.instant('FORMS.LAST_NAME'),
                    placeholder: `${this.translate.instant('FORMS.EX')} ${this.translate.instant('FORMS.LAST_NAME')}`,
                    defaultValue: this.formValues?.lastName,
                    isDisable: !this.dataObj?.data?.visible,
                    widthClass: 'col-12',
                    validation: [{ function: Validators.required, errorMessage: `${this.translate.instant('GENERAL.PLEASE_ENTER')} ${this.translate.instant('FORMS.LAST_NAME')}` }]
                }
            ];

            if (!this.dataObj?.data?.visible && this.UserId) {
                this.form.push({
                    type: AllInputTypes.Email,
                    name: 'email',
                    label: this.translate.instant('FORMS.EMAIL'),
                    placeholder: `${this.translate.instant('FORMS.EX')} email@email.com`,
                    defaultValue: this.formValues?.email,
                    isDisable: true,
                    widthClass: 'col-12',
                    validation: [{ function: Validators.required, errorMessage: `${this.translate.instant('GENERAL.PLEASE_ENTER')} ${this.translate.instant('FORMS.EMAIL')}` }]
                });
            }
        } else {
            this.form = [
                getIdFormConfig(this.dataObj?.data?.item?.id),
                {
                    type: AllInputTypes.Text,
                    name: 'firstName',
                    label: this.translate.instant('FORMS.FIRST_NAME'),
                    placeholder: `${this.translate.instant('FORMS.EX')} ${this.translate.instant('FORMS.FIRST_NAME')}`,
                    defaultValue: this.formValues?.firstName,
                    isDisable: !this.dataObj?.data?.visible,
                    widthClass: 'col-12',
                    validation: [{ function: Validators.required, errorMessage: `${this.translate.instant('GENERAL.PLEASE_ENTER')} ${this.translate.instant('FORMS.FIRST_NAME')}` }]
                },
                {
                    type: AllInputTypes.Text,
                    name: 'lastName',
                    label: this.translate.instant('FORMS.LAST_NAME'),
                    placeholder: `${this.translate.instant('FORMS.EX')} ${this.translate.instant('FORMS.LAST_NAME')}`,
                    defaultValue: this.formValues?.lastName,
                    isDisable: !this.dataObj?.data?.visible,
                    widthClass: 'col-12',
                    validation: [{ function: Validators.required, errorMessage: `${this.translate.instant('GENERAL.PLEASE_ENTER')} ${this.translate.instant('FORMS.LAST_NAME')}` }]
                },
                {
                    type: AllInputTypes.MultiSelect,
                    name: 'systemRoles',
                    label: this.translate.instant('USER_MANAGEMENT.SYSTEM_ROLES'),
                    placeholder: this.translate.instant('GENERAL.SELECT'),
                    widthClass: 'col-12',
                    listValues: [],
                    defaultValue: this.formValues?.systemRoles,
                    validation: [
                        {
                            function: Validators.required,
                            errorMessage: `${this.translate.instant('GENERAL.PLEASE_SELECT')} ${this.translate.instant('USER_MANAGEMENT.SYSTEM_ROLES')}`
                        }
                    ]
                },
                {
                    type: AllInputTypes.Email,
                    name: 'email',
                    label: this.translate.instant('FORMS.EMAIL'),
                    placeholder: `${this.translate.instant('FORMS.EX')} email@email.com`,
                    defaultValue: this.formValues?.email,
                    isDisable: !this.dataObj?.data?.visible,
                    widthClass: 'col-12',
                    validation: [{ function: Validators.required, errorMessage: `${this.translate.instant('GENERAL.PLEASE_ENTER')} ${this.translate.instant('FORMS.EMAIL')}` }]
                }
            ];

            if (this.dataObj?.data?.visible) {
                this.form.push({
                    type: AllInputTypes.Password,
                    name: 'password',
                    label: this.translate.instant('FORMS.PASSWORD'),
                    placeholder: `${this.translate.instant('FORMS.EX')} P@ssw0rd`,
                    widthClass: 'col-md-12',
                    defaultValue: this.formValues?.password,
                    validation: [{ function: Validators.required, errorMessage: `${this.translate.instant('GENERAL.PLEASE_ENTER')} ${this.translate.instant('FORMS.PASSWORD')}` }]
                });
            }
        }
    }
    valueChanged(data: any) {
        this.formValues = { ...data };
    }

    onClose(data?: any) {
        this.ref.close(data);
    }
    emitValidation() {
        this.validationEmit = !this.validationEmit;
        this.cdr.detectChanges();
    }

    async submitForm(data: any) {}

    ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
